import { productService } from "~/services/productService";
import type { APIProduct } from "~~/shared/types/product";

export const useProductDetail = (opts: { id?: string | number; slug?: string }) => {
    const identifier = opts.slug ?? opts.id;
    if (!identifier) return { data: ref(null), pending: ref(false), refresh: () => {} };

    return useAsyncData<APIProduct | null>(
        `northland:product:${identifier}`,
        async () => {
            const res = await productService.getProductDetail(identifier);
            return res?.data ?? null;
        }
    );
};
